

import { typeDeviceService } from "@/services/type-device.service";
import TypeDeviceModel from "../models/type-device";
import {Component, Vue, Watch} from "vue-property-decorator";
import { VForm } from '@/types';
import { authService } from "@/services/authentification.service";
import ConfirmComponent from "@/components/ConfirmComponent.vue";
import {Filter, Sort} from "@/models/common";

@Component({
  components: { ConfirmComponent }
})
export default class TypeDevice extends Vue {
  private typeDevices: Array<TypeDeviceModel> = new Array<TypeDeviceModel>();
  private editedItem = new TypeDeviceModel();
  private defaultItem = new TypeDeviceModel();

  private displayEditDialog = false;
  private displayConfirmDialog = false;
  private editedIndex = -1;
  private totalTypeDevices = 0;
  private loading = true;

  private saveLoading = false;
  private deleteLoading = false;

  private pagination = {
    page: 1,
    itemsPerPage: 50,
    pageStart: 0,
    pageStop: 50,
    pageCount: 0,
    itemsLength: 0,
  };

  private options = {
    itemsPerPage: 50,
    page: 1
  };

  private headers = [
    { text: "Вид", value: "type", sortable: false },
    { text: "Действия", value: "actions", sortable: false },
  ];

  private valid = true;

  async mounted() {
    const employee = await authService.getCurrentUser();
    if (employee?.role?.name === "Root") {
      this.headers.unshift({text: "Ид", sortable: false, value: "id"});
    }
  }

  @Watch("options", {deep: true})
  async loadTypeDevices() {
    try {
      this.loading = true;
      const {page, itemsPerPage} = this.options;
      const offset = (page - 1) * itemsPerPage;
      const count = itemsPerPage == -1 ? this.totalTypeDevices : itemsPerPage;
      const sorts = new Array<Sort>();
      const filters = new Array<Filter>();

      this.pagination.pageStart = offset;
      this.pagination.pageStop = offset + itemsPerPage;

      const res = await typeDeviceService.getPageData(offset, count, sorts, filters);
      this.typeDevices = res.data.collection;
      this.totalTypeDevices = res.data.count;
      this.pagination.itemsLength = res.data.count;
      this.pagination.pageCount = Math.ceil(res.data.count / 50);
    }
    catch (ex) {
      this.$toast.error("Ошибка при загрузке данных");
    }
    this.loading = false;
  }

  showEditDialog(item: TypeDeviceModel) {
    this.editedIndex = this.typeDevices.indexOf(item);
    this.editedItem = Object.assign({}, item);
    this.displayEditDialog = true;
  }

  showDeleteDialog(item: TypeDeviceModel) {
    this.editedIndex = this.typeDevices.indexOf(item);
    this.editedItem = Object.assign({}, item);
    this.displayConfirmDialog = true;
  }

  async deleteTypeDevice() {
    try {
      this.deleteLoading = true;
      const item = this.editedItem;
      await typeDeviceService.delete(item.id);
      await this.loadTypeDevices();
    }
    catch (ex) {
      this.$toast.error("Ошибка при удалении");
    }
    this.deleteLoading = false;
    this.close();
  }

  close() {
    this.displayConfirmDialog = false;
    this.displayEditDialog = false;
    this.form?.resetValidation();
    this.$nextTick(() => {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    });
  }

  get form(): VForm {
    return this.$refs.form as VForm;
  }

  async save() {
    this.form?.validate();
    if (this.valid) {
      this.saveLoading = true;
      const index = this.editedIndex;
      try {
        if (index > -1) {
          await typeDeviceService.update(this.editedItem);
        } else {
          await typeDeviceService.create(this.editedItem);
        }
        await this.loadTypeDevices();
      } catch (ex) {
        this.$toast.error("Ошибка при сохранении");
      }
      this.saveLoading = false;
      this.close();
    }
  }
}
